// Formatação pt-BR única do app: "R$ 83,20", não "R$ 83.20". Todo valor exibido passa por aqui.
const BRL = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' });

/** Valor em reais com centavos: R$ 1.234,50 */
export function formatBRL(value: number): string {
  return BRL.format(value);
}

/** Número com 2 casas no padrão brasileiro, sem "R$": 1.234,50 */
export function formatDecimal(value: number, fractionDigits = 2): string {
  return value.toLocaleString('pt-BR', { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits });
}
